import React, { useRef } from "react"

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PasswordConfirmationInputGroup from "@app/components/3_modules/PasswordConfirmationInputGroup";
import { apiCall } from '@app/utils/apiCall';
import { useTranslation } from "react-i18next";
import { useToast } from '@app/components/3_modules/ToastContainer';

import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";

export default function PasswordResetEdit() {
    const refInputPasswords = useRef();
        
    const { t } = useTranslation();

    const params = useParams();
    const [searchParams] = useSearchParams();
    const toast = useToast();  
    const navigate = useNavigate();

    function updatePassword(event) {
        event.preventDefault();

        apiCall({
            method: "patch", 
            path: "/api/v1/password_reset/" + params.reset_token,
            data: {
                email: searchParams.get("email"),
                user: {
                    password: refInputPasswords.current.getValue().password,
                    password_confirmation: refInputPasswords.current.getValue().confirmation
                }
            },
            onSuccess:(response)=>{
                toast.addToast(
                    t(response.data.message),
                    ""                    
                );
                navigate("/sign-in");
            },
            onError:(error)=>{
                toast.addToast(
                    "", 
                    t(error.response.data.message)
                );                               
            }
        })
    }

    return (
        <div className="row justify-content-center me-0">
            <div className="col-xxl-6 col-lg-8 col-md-12 standard-frame">
                <h1>Enregistrez votre nouveau mot de passe</h1>
                <p>
                    "(Utiliser 8 caractères ou plus, une majuscule, 
                    une minuscule, un chiffre et caractère spécial obligatoires)"
                </p>
                <form onSubmit={updatePassword}>
                    <PasswordConfirmationInputGroup ref={refInputPasswords} isRequired={true} />
                    <div className="form-group">
                        <ButtonPrimary label={"Mettre à jour"} />
                    </div>
                </form>
            </div>
        </div>
    )
}